export default "__VITE_ASSET__DR1WM$97__"